"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionAttribute = void 0;
var tslib_1 = require("tslib");
var PluralAttribute_1 = require("./PluralAttribute");
var CollectionAttribute = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionAttribute, _super);
    /**
     * @param name - the name of the attribute
     * @param typeConstructor - The collection constructor of the attribute
     * @param elementType - The element type of the collection
     */
    function CollectionAttribute(name, typeConstructor, elementType) {
        var _this = _super.call(this, name, typeConstructor, elementType) || this;
        _this = _super.call(this, name, typeConstructor, elementType) || this;
        return _this;
    }
    Object.defineProperty(CollectionAttribute.prototype, "collectionType", {
        /**
         * @inheritDoc
         */
        get: function () {
            return PluralAttribute_1.CollectionType.COLLECTION;
        },
        enumerable: false,
        configurable: true
    });
    return CollectionAttribute;
}(PluralAttribute_1.PluralAttribute));
exports.CollectionAttribute = CollectionAttribute;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29sbGVjdGlvbkF0dHJpYnV0ZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIkNvbGxlY3Rpb25BdHRyaWJ1dGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7OztBQUFBLHFEQUFvRTtBQUlwRTtJQUF3RCwrQ0FBcUI7SUFRM0U7Ozs7T0FJRztJQUNILDZCQUFzQixJQUFZLEVBQUUsZUFBeUIsRUFBRSxXQUFvQjtRQUFuRixZQUNFLGtCQUFNLElBQUksRUFBRSxlQUFlLEVBQUUsV0FBVyxDQUFDLFNBRTFDO1FBREMsUUFBQSxrQkFBTSxJQUFJLEVBQUUsZUFBZSxFQUFFLFdBQVcsQ0FBQyxTQUFDOztJQUM1QyxDQUFDO0lBWkQsc0JBQUksK0NBQWM7UUFIbEI7O1dBRUc7YUFDSDtZQUNFLE9BQU8sZ0NBQWMsQ0FBQyxVQUFVLENBQUM7UUFDbkMsQ0FBQzs7O09BQUE7SUFXSCwwQkFBQztBQUFELENBQUMsQUFqQkQsQ0FBd0QsaUNBQWUsR0FpQnRFO0FBakJxQixrREFBbUIifQ==